import React from "react";
import PropTypes from "prop-types";
import { observer, inject } from "mobx-react";

import copy from "./copy.json";
import { pushApplicationFlow } from "../../../utils/gtm-utils";

const _formatContactAddress = (address) =>
    address ? address.split("\n") : undefined;

function _computeContactInfo(dealershipStore, partnerStore) {
    const dealership = dealershipStore && dealershipStore.dealership;
    if (dealership && dealership.contact_name) {
        return {
            contact_name: dealership.contact_name,
            contact_address: _formatContactAddress(dealership.contact_address),
            contact_phone_number: dealership.contact_phone_number,
            contact_email_address: dealership.contact_email_address,
        };
    }

    const partner = partnerStore && partnerStore.partner;
    if (partner && partner.contact_name) {
        return {
            contact_name: partner.contact_name,
            contact_address: _formatContactAddress(partner.contact_address),
            contact_phone_number: partner.contact_phone_number,
            contact_email_address: partner.contact_email_address,
        };
    }

    return null;
}

export const DigitalCreditAppConfirmation = inject(
    "dealershipStore",
    "partnerStore",
)(
    observer(
        class _DigitalCreditAppConfirmation extends React.Component {
            static propTypes = {
                applicationUuid: PropTypes.string,
            };

            get contactInfo() {
                return _computeContactInfo(
                    this.props.dealershipStore,
                    this.props.partnerStore,
                );
            }

            componentDidMount() {
                window.scrollTo(0, 0);
                pushApplicationFlow(
                    this.props.applicationUuid,
                    "application_submitted",
                );
            }

            render() {
                const { headline, offers_valid, next_step, about_your_dealer } =
                    copy.application_submitted;
                const contact = this.contactInfo;

                return (
                    <div>
                        {/* decision-style block: headline + subheading */}
                        <div
                            className="w-500px mw-100 mx-auto pt-4 pb-3"
                            data-oid="digital-credit-app-confirmation"
                        >
                            <div className="text-center">
                                <p className="spark-text-montserrat spark-text-24px spark-text-italic spark-text-success">
                                    {headline}
                                </p>
                                <p className="mt-2">{offers_valid}</p>
                            </div>
                        </div>

                        {/* "Take the next step" instruction block */}
                        <div className="w-500px mw-100 mx-auto py-4 border-top">
                            <div className="text-center">
                                <p className="mb-3 spark-text-24px-bold">{next_step.headline}</p>
                                <p>{next_step.body}</p>
                            </div>
                        </div>

                        {/* "About your dealer" contact block (only when contact info exists) */}
                        {contact && (
                            <div
                                className="w-500px mw-100 mx-auto py-4 border-top"
                                data-oid="digital-credit-app-confirmation-dealer"
                            >
                                <div className="text-center">
                                    <p className="mb-3 spark-text-24px-bold">{about_your_dealer}</p>
                                    {contact.contact_name && <p>{contact.contact_name}</p>}
                                    {contact.contact_phone_number && <p>{contact.contact_phone_number}</p>}
                                    {!!contact.contact_email_address && <p>{contact.contact_email_address}</p>}
                                    {contact.contact_address && contact.contact_address.map((line, idx) => (
                                        <p key={`dealer-address-line-${idx}`}>{line}</p>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>
                );
            }
        },
    ),
);
